import api from '@/store/api'

export default {

  loadQuarters ({ commit }) {
    return api.get('quarter')
      .then(res => commit('SET_QUARTERS', res.data))
      .catch(error => console.log(error))
  },

  loadSectors ({ commit }) {
    return api.get('sector')
      .then(res => commit('SET_SECTORS', res.data))
      .catch(error => console.log(error))
  },

  loadClassifications ({ commit }) {
    return api.get('fund_classifications')
      .then(res => commit('SET_CLASSIFICATIONS', res.data))
      .catch(error => console.log(error))
  },

  loadStockCountries ({ commit }) {
    return api.get('stock_country')
      .then(res => commit('SET_STOCK_COUNTRIES', res.data))
      .catch(error => console.log(error))
  },
  loadCountries ({ commit }) {
    return api.get('country')
      .then(res => commit('SET_COUNTRIES', res.data))
      .catch(error => console.log(error))
  },

  loadSECCodeStates ({ commit }) {
    return api.get('sec_code_state')
      .then(res => commit('SET_SEC_CODE_STATES', res.data))
      .catch(error => console.log(error))
  },

  loadStates ({ commit }) {
    return api.get('state')
      .then(res => commit('SET_STATES', res.data))
      .catch(error => console.log(error))
  },
  loadGlobalCountries ({ commit }) {
    return api.get('global_country')
      .then(res => commit('SET_GLOBAL_COUNTRIES', res.data))
      .catch(error => console.log(error))
  },
  loadGlobalExchanges ({ commit }) {
    return api.get('global_exchanges')
      .then(res => commit('SET_GLOBAL_EXCHANGES', res.data))
      .catch(error => console.log(error))
  },
  loadWWGroups ({ commit }) {
    return api.get('groups.json?groups=ww&isArray=true')
      .then(res => commit('SET_WW_GROUPS', res.data))
      .catch(error => console.log(error))
  },

  loadOwnershipTCodes ({ commit }) {
    return api.get('ownership_transaction_code')
      .then(res => commit('SET_OWNERSHIP_T_CODES', res.data))
      .catch(error => console.log(error))
  },

  loadNews ({ commit }) {
    return api.get('news')
      .then(res => commit('SET_NEWS', res.data))
      .catch(error => console.log(error))
  }

}
